import {ajax, getRequestUrl, formatData, uploadImg} from "../request";
// 房间专栏

export default {
  uploadRoomsExcel(data) {
    return uploadImg(getRequestUrl('/api/RoomTopic/uploadRoomsExcel'), data)
  },

  hurdleDelete(data, method) {
    return ajax('post', getRequestUrl('/banner/hurdleDelete'), data, {
      method,
    });
  },

  room_hurdleOn(data, method) {
    return ajax('post', getRequestUrl('/api/RoomTopic/hurdleOn'), data, {
      method,
    });
  },

  roomBannerListByPage(data, method) {
    return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerListByPage'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  roomBannerIsOn(data, method) {
    return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerIsOn'), data, {
      method,
    });
  },

  roomBannerDelete(data, method) {
    return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerDelete'), data, {
      method,
    });
  },

  roomBannerInfo(data, method) {
    return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerInfo'), data, {
      method,
    });
  },

  roomBannerSave(data, method) {
    return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerSave'), data, {
      method,
    });
  },

  roomBannerApplicationList(data, method) {
    return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerApplicationList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  roomBannerApplicationDelete(data, method) {
    return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerApplicationDelete'), data, {
      method,
    });
  },

  roomBannerApplicationInfo(data, method) {
    return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerApplicationInfo'), data, {
      method,
    });
  },

  roomBannerApplicationSave(data, method) {
    return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerApplicationSave'), data, {
      method,
    });
  },

  roomBannerApplicationCheck(data, method) {
    return ajax('post', getRequestUrl('/api/RoomTopic/roomBannerApplicationCheck'), data, {
      method,
    });
  },

  hurdleList(data, method) {
    return ajax('post', getRequestUrl('/banner/hurdleList'), data, {
      method,
    });
  },

  hurdleSave(data, method) {
    return ajax('post', getRequestUrl('/banner/hurdleSave'), data, {
      method,
    });
  },

  hurdleRoomList(data, method) {
    return ajax('post', getRequestUrl('/api/RoomTopic/hurdleRoomList'), data, {
      method,
    });
  },

  hurdleRoomSave(data, method) {
    return ajax('post', getRequestUrl('/api/RoomTopic/hurdleRoomSave'), data, {
      method,
    });
  },

  hurdleRoomDelete(data, method) {
    return ajax('post', getRequestUrl('/api/RoomTopic/hurdleRoomDelete'), data, {
      method,
    });
  },
}



// WEBPACK FOOTER //
// ./src/js/https/roomColumn.js